import React, { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Main } from '@expo/html-elements';
import {
  DisplayText,
  IllusEmpty_2,
  Image,
  theme,
  useNoticeBannersStackContext,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { PageWrapperSafeAreaView } from '../../components/PageWrapper/PageWrapperSafeAreaView';
import { preventScreenDismissalIfNecessary } from './MaintenanceModeScreen.utils';

// ────────────────────────────────────────────────────────────────────────────────

export const MaintenanceModeScreen = () => {
  const navigation = useNavigation();
  const { t } = useLocalizationContext();
  const { disable: disableNoticeBanners, enable: enableNoticeBanners } =
    useNoticeBannersStackContext();

  // ─────────────────────────────────────────────────────────────────

  // avoid closing this screen unless it is necessary since maintenance mode has been turned off
  useLayoutEffect(() => {
    navigation.addListener('beforeRemove', preventScreenDismissalIfNecessary);

    return () => {
      navigation.removeListener(
        'beforeRemove',
        preventScreenDismissalIfNecessary,
      );
    };
  }, [navigation]);

  // block new notifications, while in maintenance mode
  useLayoutEffect(() => {
    disableNoticeBanners();

    return enableNoticeBanners;
  }, [disableNoticeBanners, enableNoticeBanners]);

  // ─────────────────────────────────────────────────────────────────

  return (
    <View testID="maintenance-mode" style={styles.contentContainerStyle}>
      <PageWrapperSafeAreaView edges={['top']}>
        <Main style={styles.wrapper}>
          <Image
            source={IllusEmpty_2}
            style={styles.img}
            accessibilityIgnoresInvertColors
            resizeMode="contain"
          />

          <DisplayText
            size={3}
            style={[styles.heading, styles.headingSM]}
            accessibilityRole="header"
            accessibilityLevel={1}
          >
            {t('general.maintenance-message')}
          </DisplayText>
        </Main>
      </PageWrapperSafeAreaView>
    </View>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentContainerStyle: {
    flexGrow: 1,
    backgroundColor: theme.colors.OATMEAL,
    alignItems: 'center',
  },
  wrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 660,
    paddingVertical: theme.spacing.medium,
    paddingHorizontal: theme.spacing.large,
  },
  img: {
    width: 200,
    height: 200,
  },
  heading: {
    marginTop: theme.spacing.medium,
    textAlign: 'center',
  },
  headingSM: {
    textAlign: 'center',
  },
});
